import script from "./DriverTravelView.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverTravelView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__